<template>
  <div>
    <search-traffic-pool @submit="submitSearch" />

    <a-table
      size="middle"
      :columns="tableColumns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :scroll="{ x: 'max-content' }"
      row-key="id"
    >
      <div slot="name" slot-scope="name, record">
        <div v-if="isShowMenu('customer/traffic_pools/show')">
          <router-link :to="{ name: 'pool_info', params: { id: record.id }}"> {{ name }} </router-link>
        </div>
        <div v-else> {{ name }} </div>
      </div>

      <span slot="actions" slot-scope="text, record">
        <a-dropdown>
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            操作 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-if="isHasSetPoolAlarmPermission">
              <a @click="showSetAlarmModal(record.id, record.is_alarm, record.alarm_type, record.alarm_value)">告警配置</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>

    <pagination
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <!-- 设置告警模态框 -->
    <set-pool-alarm
      v-if="isShowSetAlarmModal"
      :visible.sync="isShowSetAlarmModal"
      :id="settingId"
      :is-alarm="isAlarm"
      :alarm-type="alarmType"
      :alarm-value="alarmValue"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination/index'
import { findTrafficPools } from '@/api/traffic_pool'
import { hasPermission } from '@/utils/permission'
import SearchTrafficPool from '@/views/traffic_pools/Search'

export default {
  name: 'TrafficPoolList',
  components: {
    Pagination,
    SearchTrafficPool,
    SetPoolAlarm: () => import('@/views/traffic_pools/SetPoolAlarm')
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowSetAlarmModal: false, // 是否显示配置表单弹窗
      settingId: 0, // 正在配置的记录id
      isAlarm: undefined,
      alarmType: undefined,
      alarmValue: undefined,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    agentId() {
      if (this.$route.query.agent_id) {
        return parseInt(this.$route.query.agent_id)
      }

      return this.$store.getters.userAgentId
    },

    tableColumns() {
      var columnArr = [
        {
          title: '流量池名称',
          dataIndex: 'name',
          fixed: 'left',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '流量池编号',
          dataIndex: 'no'
        },
        {
          title: '运营商种类',
          dataIndex: 'carrier_type'
        },
        {
          title: '用户业务模式',
          dataIndex: 'user_business_type'
        },
        {
          title: '本周期可用总流量',
          dataIndex: 'total_traffic'
        },
        {
          title: '本周期已用流量',
          dataIndex: 'used_traffic'
        },
        {
          title: '本周期剩余流量',
          dataIndex: 'left_traffic'
        },
        {
          title: '使用进度',
          dataIndex: 'usage_progress'
        },
        {
          title: '卡号总数',
          dataIndex: 'card_count'
        },
        {
          title: '可用卡数',
          dataIndex: 'available_card_count'
        }
      ]

      if (this.$store.getters.userRole === 'top_agent') {
        columnArr.push({
          title: '操作',
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' },
          fixed: 'right'
        })
      }

      return columnArr
    },

    isHasSetPoolAlarmPermission() {
      return hasPermission('customer/traffic_pools/set_alarm')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    showSetAlarmModal(recordId, isAlarm, alarmType, alarmValue) {
      this.settingId = recordId
      this.isAlarm = isAlarm

      if (isAlarm) {
        this.alarmType = alarmType
        this.alarmValue = alarmValue
      } else {
        this.alarmType = NaN
        this.alarmValue = 0
      }

      this.isShowSetAlarmModal = true
    },

    submitSearch(search) {
      // 重置排序
      this.sort = this.$options.data().sort
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findTrafficPools(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        this.data = res.data
        this.pagination.total_count = res.pagination.total_count
        this.loading = false
      })
    }
  }
}
</script>

